import { Image } from 'react-native'
import { Images as foundationImages } from '@vfgroup-oneplatform/foundation/Components/Themes'

const Images = {
  chevronRightRed: foundationImages.ic_chevron_right_red,

  info: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/info.png'),
  ),
  close: foundationImages.ic_close,

  reward: Image.resolveAssetSource(
    require('./../Images/Icons/HIFI/reward.png'),
  ),
  info_red: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/info_red.png'),
  ),
  steps: Image.resolveAssetSource(
    require('./../Images/Icons/HIFI/steps.png'),
  ),
  more: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/more.png'),
  ),
  topUp: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/topUp.png'),
  ),
  mobile: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/mobile.png'),
  ),
  arrowLeftWhite: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/arrowLeftWhite.png'),
  ),
  background_waves_red: Image.resolveAssetSource(
    require('./../Images/Icons/HIFI/wavesRed.png')
  ),

  //entry data images

  image1: Image.resolveAssetSource(
    require('./../Images/EntryDataImages/1.png'),
  ),
  image2: Image.resolveAssetSource(
    require('./../Images/EntryDataImages/2.png'),
  ),
  image3: Image.resolveAssetSource(
    require('./../Images/EntryDataImages/3.png'),
  ),
  image4: Image.resolveAssetSource(
    require('./../Images/EntryDataImages/4.png'),
  ),
  image5: Image.resolveAssetSource(
    require('./../Images/EntryDataImages/5.png'),
  ),

}

export default Images
